import React from "react";
import { Route, Switch } from "react-router";
import ProspectsBuilder from "../ProspectsBuilder";

export const ProspectsContainer = () => {
  return (
    <div className="broker-builder">
      <main className="broker__wrap">
        <section className="broker__container">
          <Switch>
            <Route path="/prospects/new" render={props => <ProspectsBuilder {...(props as any)} />} />
            <Route path="/prospects/:id" render={props => <ProspectsBuilder {...(props as any)} />} />
          </Switch>
        </section>
      </main>
    </div>
  );
};
